import { render } from "./PediatricDentistry.vue?vue&type=template&id=601b92ab"
import script from "./PediatricDentistry.vue?vue&type=script&lang=js"
export * from "./PediatricDentistry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__